

export class Model_CRM_AdvancePayment {

    public AdvanceId: number;
    public AdvancePayment: string;

}       